var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.92 10.55 8.759 8.387m1.168-2.81a3.978 3.978 0 1 1-7.955 0 3.978 3.978 0 0 1 7.955 0Z",
    stroke: "#C6C6C6",
    strokeWidth: 1.119,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSearch;